import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import PropTypes from 'prop-types';

import { Icon } from 'Icons';

import ButtonBase from './ButtonBase';

const closeButtonStyles = {
  danger: 'text-red-4 hover:text-red-4',
  default: 'text-gray-4 close-button-hover-default',
  info: 'text-blue-4 hover:text-blue-4',
  pantheor: 'text-purple-4 hover:text-purple-4',
  success: 'text-green-4 hover:text-green-4',
  warning: 'text-orange-4 hover:text-orange-4',
};

const CloseButton = ({ callback, className, type }) => (
  <ButtonBase
    aria-label="Close"
    className={`close-button ${className || ''} ${
      closeButtonStyles[type] || closeButtonStyles.default
    }`}
    onClick={callback}
  >
    <Icon icon={faTimes} />
  </ButtonBase>
);

CloseButton.defaultProps = {
  className: '',
  type: 'default',
};

CloseButton.propTypes = {
  callback: PropTypes.func.isRequired,
  className: PropTypes.string,
  type: PropTypes.string,
};

export default CloseButton;
